import type { Appearance } from "@clerk/types";

/** Estilos extra para `<SignUp />` / `<SignIn />` embebidos (el logo global está en `ClerkProvider`). */
export function getRegistroClerkAppearance(): Appearance {
  return {
    elements: {
      rootBox: "w-full mx-auto",
      headerTitle: "text-zinc-100",
      headerSubtitle: "text-zinc-400",
      footer: "text-zinc-500",
      cardBox: "!shadow-none bg-transparent border-0 p-0",
    },
    variables: {
      colorPrimary: "hsl(var(--primary))",
      colorBackground: "transparent",
      colorText: "hsl(240, 5%, 95%)",
      colorTextSecondary: "hsl(240, 5%, 65%)",
      colorInputBackground: "hsl(240, 8%, 16%)",
      colorInputText: "hsl(240, 5%, 95%)",
      colorNeutral: "hsl(240, 5%, 95%)",
      borderRadius: "var(--radius)",
    },
  };
}
